import Dialog from "@hydrologiq/shared/chakra/Dialog"
import { ActionButton } from "@hydrologiq/shared/content/components/Button"
import { Text, Dialog as ChakraDialog } from "@chakra-ui/react"
import { toaster } from "@hydrologiq/shared/chakra/Toaster"

interface DeactivateAssignmentDialogProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  loading: boolean
}

const DeactivateAssignmentDialog = ({ open, onClose, onConfirm, loading }: DeactivateAssignmentDialogProps) => {
  const handleConfirm = async () => {
    try {
      await onConfirm()
    } catch (error: any) {
      toaster.error({
        title: "Failed to remove assignment",
        description: error?.message || "An unexpected error occurred",
      })
    }
  }

  return (
    <Dialog
      title="Remove assignment"
      open={open}
      setOpen={(isOpen) => {
        if (!isOpen) onClose()
      }}
      footer={
        <>
          <ChakraDialog.ActionTrigger asChild>
            <ActionButton
              disabled={loading}
              context={{ label: "Remove", description: "Remove the current assignment", variant: "warning" }}
              onClick={handleConfirm}
            />
          </ChakraDialog.ActionTrigger>
          <ActionButton
            disabled={loading}
            onClick={onClose}
            context={{
              label: "Cancel",
              description: "Cancel and keep the current assignment",
              variant: "secondary",
            }}
          />
        </>
      }
      loading={loading}
      disabled={loading}
    >
      <Text>
        Are you sure you want to remove the current assignment? This will set an end date on the assignment, making it
        inactive. The assignment history will be preserved.
      </Text>
    </Dialog>
  )
}

export default DeactivateAssignmentDialog
